<template>
  <div class="menu">
    <div>
      <a href="#" @click.prevent="$emit('toggleFilters')" class="btn btn-sm btn-secondary">
        <i class="fa fa-filter"></i>
      </a>
    </div>
    <div>
      <button
        type="button"
        class="btn btn-sm btn-success"
        @click="$emit('addTask')"
        v-if="!addingTask && canAdd"
      >
        <i class="fa fa-plus"></i>
      </button>
      <button
        type="button"
        class="btn btn-sm btn-secondary ml-1"
        @click="$emit('close')"
        v-if="addingTask"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      addingTask: {
        type: Boolean,
        default: false,
      },
      canAdd: {
        type: Boolean,
        default: false,
      },
    }
  }
</script>



// WEBPACK FOOTER //
// assets/js/components/kanban/Menu.vue